var _rect, _path, _g, _circle, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEarlyestLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1075_6731)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "#FF832B"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1075_6731",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -24,
    y: -4,
    width: 84,
    height: 84
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 38C60 61.196 41.196 80 18 80C-5.19596 80 -24 61.196 -24 38C-24 14.804 -5.19596 -4 18 -4C41.196 -4 60 14.804 60 38Z",
    fill: "#90CAF9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1075_6731)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-12.9124 10.1221C-14.3915 13.6406 -15.1994 17.4475 -15.1994 21.4222C-15.1994 39.2152 1.05921 53.7926 21.3157 53.7926C40.0653 53.7926 55.4046 41.2924 57.5684 25.323L59.1292 25.5345C56.8424 42.4116 40.7183 55.3676 21.3157 55.3676C0.368879 55.3676 -16.7744 40.2543 -16.7744 21.4222C-16.7744 17.2313 -15.922 13.2173 -14.3643 9.51172L-12.9124 10.1221Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-23.0197 43.3105C-18.3021 59.911 -1.21876 72.3041 19.244 72.3041C34.4813 72.3041 47.8621 65.4257 55.6402 55.049L56.9004 55.9936C48.8077 66.7901 34.9478 73.8791 19.244 73.8791C-1.81994 73.8791 -19.5979 61.1128 -24.5347 43.7411L-23.0197 43.3105Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5581 -2.93672C9.91766 -2.93672 -0.00312507 5.15991 -0.00312507 14.7889C-0.00312507 24.418 9.91766 32.5146 22.5581 32.5146C35.1985 32.5146 45.1192 24.418 45.1192 14.7889C45.1192 9.38997 42.0321 4.50019 37.0602 1.21575L37.9283 -0.0983987C43.2378 3.40905 46.6942 8.74767 46.6942 14.7889C46.6942 25.609 35.7079 34.0896 22.5581 34.0896C9.40822 34.0896 -1.57812 25.609 -1.57812 14.7889C-1.57812 3.96889 9.40822 -4.51172 22.5581 -4.51172V-2.93672Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.0343 40.2379C34.5021 24.5199 26.9262 18.2345 22.3071 15.614L23.0843 14.2441C28.0441 17.0579 35.839 23.6327 42.4887 39.6335C46.9489 50.3657 48.7561 61.087 50.1373 69.5122L48.5831 69.767C47.2011 61.337 45.4162 50.782 41.0343 40.2379Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.2181 21.1041C36.6899 15.9419 26.9532 15.4463 23.0537 15.8498L22.8916 14.2831C27.0052 13.8576 37.1632 14.3567 45.1088 19.8051C54.9254 26.5365 60.4191 35.7991 61.9916 40.6595L60.4931 41.1443C59.0261 36.6101 53.7435 27.6358 44.2181 21.1041Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.7426 8.59416C43.293 8.09421 41.0146 7.9176 35.6059 9.33418C31.144 10.5028 25.4712 13.8443 23.3228 15.5451L22.3452 14.3102C24.6179 12.511 30.4836 9.04765 35.2069 7.81057C40.8739 6.32632 43.3792 6.52069 49.8337 7.02146C50.147 7.04576 50.4696 7.07079 50.8023 7.09639L50.6815 8.66675C50.3588 8.64192 50.0461 8.61768 49.7426 8.59416Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.7926 6.10799C25.7272 9.62685 24.2782 13.0857 23.5811 15.177L22.0869 14.6789C22.8175 12.4873 24.3112 8.92772 26.4343 5.31072C28.5524 1.70218 31.3336 -2.02726 34.6611 -4.49414L35.5991 -3.22892C32.516 -0.943177 29.863 2.58068 27.7926 6.10799Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4774 1.37409C19.9877 6.19426 22.5959 11.5648 23.4567 14.7209L21.9372 15.1354C21.14 12.2126 18.6363 7.01401 15.2042 2.30129C13.4933 -0.0481167 11.5699 -2.25094 9.53884 -3.9781C7.50245 -5.70976 5.39904 -6.92812 3.32715 -7.37437L3.65877 -8.91406C6.07702 -8.39321 8.41192 -7.00384 10.5591 -5.17794C12.7116 -3.34752 14.7172 -1.04295 16.4774 1.37409Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-23.7227 9.63095C-1.64594 1.45024 16.6925 9.47728 23.166 14.2969L22.2254 15.5603C16.0805 10.9852 -1.70473 3.15168 -23.1754 11.1078L-23.7227 9.63095Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-12.4882 22.9682C-1.05079 14.3813 12.8508 13.0267 22.7849 14.1461L22.6086 15.7112C12.9243 14.6199 -0.529385 15.9593 -11.5426 24.2277C-22.5203 32.4694 -31.2263 47.7122 -31.2263 74.7509H-32.8013C-32.8013 47.3554 -23.9612 31.5818 -12.4882 22.9682Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-13.7309 123.316C-19.8299 55.7828 7.55954 22.4914 22.3139 14.2422L23.0825 15.6169C9.00788 23.4861 -18.2211 56.0868 -12.1622 123.174L-13.7309 123.316Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9907 58.9052C20.6764 42.2149 21.5872 25.4126 21.9091 15.043L23.4834 15.0918C23.1605 25.4919 22.2477 42.3311 20.5577 59.0635C18.8702 75.7714 16.4004 92.4575 12.9408 102.501L11.4517 101.989C14.8447 92.1378 17.3025 75.62 18.9907 58.9052Z",
    fill: "white"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 38,
    r: 41.25,
    stroke: "white",
    strokeWidth: 1.5
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1075_6731"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarlyestLogo);
export default __webpack_public_path__ + "static/media/earlyest-logo.a0c9660881dbd22cac1a5ccc8b9d0282.svg";
export { ForwardRef as ReactComponent };